import React, { Component } from 'react';
import InputField from './input-field.jsx'
import LoginStore from '../stores/login-store.js';
import dispatcher from '../dispatcher.js';
import debounce from 'lodash.debounce';
import { Link } from 'react-router-dom';
import { Auth } from 'aws-amplify';

class LoginForm extends Component {

	constructor(props) {
		super(props);
		this.state = Object.assign({
			isSubmitting: false
		},LoginStore.getAll());
		this.getFields = this.getFields.bind(this);
		this.validateEmail = debounce(this.validateEmail.bind(this), 500);
		this.onChangeEmail = this.onChangeEmail.bind(this);
		this.validatePassword = debounce(this.validatePassword.bind(this), 500);
		this.onChangePassword = this.onChangePassword.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.resetStatus = this.resetStatus.bind(this);
	}

	componentDidMount() {
		LoginStore.on('change', this.getFields);
	}

	getFields() {
		this.setState(LoginStore.getAll());
	}

	componentWillUnmount() {
		LoginStore.removeListener('change', this.getFields);
	}

	onChangeEmail(event) {
		const newEmail = event.target.value;
		dispatcher.dispatch({
			type: 'set_email',
			email: newEmail
		});
		this.validateEmail(newEmail);
	}

	validateEmail(newEmail) {
		dispatcher.dispatch({
			type: 'validate_email',
			email: newEmail
		});					
	}


	onChangePassword(event) {
		dispatcher.dispatch({
			type: 'set_password',
			email: event.target.value
		});
		this.validatePassword(event.target.value);
		// eslint-disable-next-line
		if(this.state.email.value && this.state.email.value.length && this.state.email.class == 'is-warning') {
			this.onChangeEmail({target: this.state.email});
		} 
	}

	validatePassword(newPassword) {
		dispatcher.dispatch({
			type: 'validate_password',
			email: newPassword
		});					
	}

	resetStatus(event) {
		dispatcher.dispatch({
			type: 'reset_status'
		});					
	}

	onSubmit(event) {
		event.preventDefault();
		this.setState({
			isSubmitting: true
		}, () => {
			Auth.signIn(this.state.email.value, this.state.password.value)
			.then((user) => {
				console.log("accesso");
				console.log(user);
				dispatcher.dispatch({
					type: 'user_logged',
					user: user
				});
				if(user.challengeName === 'NEW_PASSWORD_REQUIRED') {
					dispatcher.dispatch({
						type: 'user_confirmPassword',
						user: user
					});
					this.props.history.push('/change-password');
				} else {
					this.props.history.push('/');
				}
			})
			.catch((err) => {
				this.setState({isSubmitting: false});
				// eslint-disable-next-line
				if(err.code == 'NotAuthorizedException') {
					dispatcher.dispatch({
						type: 'wrongUserPassword'
					});
				}
			})
		})
	}

	render() {
		const btnClass = this.state.isSubmitting ? "button is-info is-medium is-loading" : "button is-info is-medium"
		const btnDisabled = this.state.email.class !== 'is-success' ||
		this.state.password.class !== 'is-success';
		return (
			<React.Fragment>
			<div className="box">
				<form onSubmit={this.onSubmit}>
					<InputField type="text" label="Email" validationClass={this.state.email.class} name="email" value={this.state.email.value} validationMessage={this.state.email.message} onChange={this.onChangeEmail}/>
					<InputField type="password" label="Password" name="password" validationClass={this.state.password.class} validationMessage={this.state.password.message} value={this.state.password.value} onChange={this.onChangePassword}/>
					<div className="field">
						<div className="control">
							<button className={btnClass} onClick={this.onSubmit} disabled={btnDisabled}>Login</button>
						</div>
					</div>
					<p>Non hai un account? <Link to="/signup" onClick={this.resetStatus}>Crea un account adesso</Link></p>
				</form>
			</div>
				{ this.props.history.location.state && this.props.history.location.state.fromSignUp && <div style={{padding: '8px'}} className="notification has-text-left is-success">Hai Ricevuto una mail! Verifica il tuo account ed effettua il login.</div> }
			</React.Fragment>
		)
	}
}

export default LoginForm


// WEBPACK FOOTER //
// ./src/components/login-form.jsx